import cm from '../../assets/cm.jpeg';
import image1 from '../../assets/home/test1.jpeg';
import image2 from '../../assets/home/test3.jpeg';
import image3 from '../../assets/home/test1.png';
import image4 from '../../assets/home/testimonial1.png';
import image5 from '../../assets/home/test4.jpeg';
import image6 from '../../assets/home/test2.webp';

export const fakeData = [
  {
    id: 1,
    img: cm,
    name: "Chuma Nwokafor",
    profession: "Construction Manager",
    message:
      "As a construction manager, working with Hendrex Resources Limited has been an absolute pleasure. Their commitment to quality, timely delivery, and attention to detail is unmatched. Their professionalism and dedication to meeting project needs make them a reliable partner for any construction endeavor. Highly recommended!",
  },
  {
    id: 2,
    img: image2,
    name: "John Brown",
    profession: "Logistics Manager",
    message:
      "We have been working with this company for several years and they have consistently provided dependable and professional logistic solutions. They have a deep understanding of our industry and have been able to tailor their services to meet our specific needs.",
  },
  {
    id: 3,
    img: image3,
    name: "Mark Johnson",
    profession: "Environmental Manager at DEF Industries",
    message:
      "We have been using this company for our waste management needs for over a year now and we are extremely satisfied with their services. They have provided us with efficient and effective solutions for our waste disposal, recycling, and hazardous waste management needs!",
  },
  {
    id: 4,
    img: image4,
    name: "Sarah Brown",
    profession: "Operations Manager at GHI Oil and Gas",
    message:
      "We have been working with this company for several years and have always been impressed with their outstanding performance and customer service. They have a deep understanding of the oil and gas industry and have been able to provide us with tailored solutions for our logistics and waste management needs.",
  },
  {
    id: 5,
    img: image5,
    name: "Thomas Jones",
    profession: "CEO at JKL Construction",
    message:
      "I have been working with this company for a number of years and can highly recommend them for their expertise in waste management, logistics, and construction. They have a deep understanding of the industry and have been able to provide us with innovative solutions for our projects. Their team is always professional, knowledgeable, and easy to work with.",
  },
  {
    id: 6,
    img: image6,
    name: "Michael Lee",
    profession: "Project Manager at MNO Corporation",
    message:
      "We have been working with this company for several months and have been impressed with their responsiveness and commitment to meeting our needs. They have provided us with efficient and effective logistics solutions that have helped us to streamline our operations and improve our bottom line. Their team is always professional, friendly, and willing to go the extra mile to ensure that we are satisfied with their services",
  },
];
